<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
    <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
        <mat-card-title>
            <div class="w-100 d-flex" style="background: #0f172a;">
                <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">
                    {{ "Configuration Agent CaurisLinkup" | translate }}
                </span>
                <button class="m-l-auto" mat-icon-button (click)="close();">
                    <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
                </button>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex: 1;padding: 0; display: flex; flex-direction: column; align-items: center">
        <clu-agent-settings-devices></clu-agent-settings-devices>
    </mat-card-content>
</mat-card>